export default __webpack_public_path__ + "static/media/kaboom.38f7acab.png";